import { ChevronLeftRounded, AccountCircle, ChevronRightRounded } from '@mui/icons-material';
import { Box, Stack, Typography } from '@mui/material';
import { DateTime } from 'luxon';
import React from 'react';
import theme from 'theme';
import {
    messageAreaStyles,
    messageBubbleStyles,
    messageDescriptorStyles,
    messageTextStyles,
    previewContainerStyles,
    previewHeaderStyles,
    receivedMessageBubbleStyles,
    sentMessageBubbleStyles,
} from './styles';

type Props = {
    formattedContent: string;
};

const MessageBubble = ({ messageText, isSent = false }: { messageText: string; isSent?: boolean }) => {
    const bubbleStyles = isSent ? sentMessageBubbleStyles : receivedMessageBubbleStyles;
    return (
        <Box sx={{ display: 'flex', mb: 1, justifyContent: isSent ? 'flex-end' : 'flex-start' }}>
            <Box sx={{ ...messageBubbleStyles, ...bubbleStyles }}>
                <Typography variant="body2" sx={{ ...messageTextStyles, color: isSent ? 'white' : 'inherit' }}>
                    {messageText}
                </Typography>
            </Box>
        </Box>
    );
};

const WhatsAppPreview = ({ formattedContent }: Props) => (
    <Stack
        height="auto"
        justifySelf="center"
        sx={{ width: '100%', maxWidth: '320px', maxHeight: 'calc(100vh - 250px)' }}
    >
        <Stack sx={previewContainerStyles}>
            {/* Header */}
            <Stack direction="row" alignItems="center" sx={previewHeaderStyles}>
                <ChevronLeftRounded fontSize="large" htmlColor={`${theme.palette.grey[400]}`} />
                <Box flex={1} ml={-5} display="flex" justifyContent="center">
                    <Stack alignItems="center">
                        <AccountCircle fontSize="large" htmlColor={`${theme.palette.grey[400]}`} />
                        <Stack direction="row" alignItems="center">
                            <Typography variant="body2" color="text.primary">
                                +1 (999) 999-9999
                            </Typography>
                            <ChevronRightRounded fontSize="small" htmlColor={`${theme.palette.grey[400]}`} />
                        </Stack>
                    </Stack>
                </Box>
            </Stack>

            {/* Message Area */}
            <Stack sx={messageAreaStyles}>
                <Typography variant="overline" sx={messageDescriptorStyles}>
                    WhatsApp Message
                    <br />
                    {DateTime.now().toFormat("ccc, MMM d 'at' h:mm a")}
                </Typography>

                <MessageBubble messageText={formattedContent} />
            </Stack>
        </Stack>
    </Stack>
);

export default React.memo(WhatsAppPreview);
